import { useQuery } from '@tanstack/react-query'
import { api } from '@api'

export interface ContactHistoryItem {
  type: 'note' | 'message' | 'event' | 'keepContact'
  id: string
  title: string
  date: string
  conversationId?: string
}

// « Historique avec X »: notes, last message, rendez-vous and « Garder
// contact » reminder about one contact, gathered by the API (past first,
// then what is planned). Nothing is copied: each line opens the original.
export const useGetContactHistory = (contactId?: string, enabled = true) => {
  return useQuery<ContactHistoryItem[]>({
    queryKey: ['contact-history', contactId],
    queryFn: async () => {
      const { data } = await api.get<{ items: ContactHistoryItem[] }>(
        `/contact-history/${encodeURIComponent(contactId ?? '')}`,
      )
      return data.items
    },
    enabled: !!contactId && enabled,
  })
}
